import styled from 'styled-components';

export const OptionButtonWrapper = styled.div<{ $large: boolean }>`
  ${({ $large }) =>
    $large
      ? `
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 0;
    margin: 1em;
  `
      : `
    margin: 0.5em;
    min-width: 525px;
    display: flex;
    justify-content: center;
  `}
`;

export const FlexWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media ${({ theme }) => theme.queries.minDesktop} {
    flex-direction: row;
  }
`;

export const VerticalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const QuizCardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  align-items: center;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.tabletLandscape}) {
    align-items: center;
  }
`;

export const OptionsListContainer = styled.div.attrs<{ 'data-testid'?: string }>({
  'data-testid': 'service-options-container'
})`
  width: 100%;

  @media ${({ theme }) => theme.queries.minTablet} {
    padding: 0 32px;
  }
`;
